/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Settings_Language_DescInputs */

const en_ui_settings_language_desc = /** @type {(inputs: Ui_Settings_Language_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your preferred language`)
};

const de_ui_settings_language_desc = /** @type {(inputs: Ui_Settings_Language_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle deine bevorzugte Sprache`)
};

/**
* | output |
* | --- |
* | "Choose your preferred language" |
*
* @param {Ui_Settings_Language_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_settings_language_desc = /** @type {((inputs?: Ui_Settings_Language_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Settings_Language_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_settings_language_desc(inputs)
	return de_ui_settings_language_desc(inputs)
});